var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.8666 1.76519C1.96942 1.42146 2.29012 1.16797 2.66545 1.16797H13.3321C13.7074 1.16797 14.0281 1.42144 14.1309 1.76514L7.99874 6.05768L1.8666 1.76519ZM0.832146 1.99019C0.832005 1.99678 0.831994 2.00336 0.832113 2.00994V10.0013C0.832113 11.0108 1.65597 11.8346 2.66545 11.8346H13.3321C14.3416 11.8346 15.1654 11.0108 15.1654 10.0013V2.00307C15.1655 2.00145 15.1655 1.99984 15.1654 1.99822C15.1638 0.990149 14.3406 0.167969 13.3321 0.167969H2.66545C1.65968 0.167969 0.838166 0.985786 0.832146 1.99019ZM14.1654 2.96165V10.0013C14.1654 10.4585 13.7893 10.8346 13.3321 10.8346H2.66545C2.20826 10.8346 1.83211 10.4585 1.83211 10.0013V2.9617L7.71201 7.07763C7.88417 7.19814 8.11331 7.19814 8.28547 7.07763L14.1654 2.96165Z",
    fill: "#121865"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.8666 1.76519C1.96942 1.42146 2.29012 1.16797 2.66545 1.16797H13.3321C13.7074 1.16797 14.0281 1.42144 14.1309 1.76514L7.99874 6.05768L1.8666 1.76519ZM0.832146 1.99019C0.832005 1.99678 0.831994 2.00336 0.832113 2.00994V10.0013C0.832113 11.0108 1.65597 11.8346 2.66545 11.8346H13.3321C14.3416 11.8346 15.1654 11.0108 15.1654 10.0013V2.00307C15.1655 2.00145 15.1655 1.99984 15.1654 1.99822C15.1638 0.990149 14.3406 0.167969 13.3321 0.167969H2.66545C1.65968 0.167969 0.838166 0.985786 0.832146 1.99019ZM14.1654 2.96165V10.0013C14.1654 10.4585 13.7893 10.8346 13.3321 10.8346H2.66545C2.20826 10.8346 1.83211 10.4585 1.83211 10.0013V2.9617L7.71201 7.07763C7.88417 7.19814 8.11331 7.19814 8.28547 7.07763L14.1654 2.96165Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.5ba6f1d69e55b4002bc108d7c47fd7f1.svg";
export { ForwardRef as ReactComponent };